import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import { useNavigate } from 'react-router-dom'
import { getConfigDetails } from '../../services/config'
import '../../components/global/qrScanCss.scss'
import CommonQr from '../../global/ScanQrCode/CommonQr'

function ScanQr(props) {
    const { notify } = props
    const [isDataRecorded, setIsDataRecorded] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (scanResult && scanResult != null) {
            //    Action for Scann

        }
    }, [scanResult])

    const handleScan = (data) => {

        if (data?.text) {
            if (!isDataRecorded) {
                //Redirect
                const url = window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revtransientURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.pcitransientURL : getConfigDetails()?.transientURL
                const facilityData = data?.text.split(`${url}/`)
                if (data?.text?.includes(url)) {
                    navigate(`/${facilityData[1]}`)
                    setScanResult(data?.text)
                    setIsDataRecorded(true)
                } else {
                    setIsDataRecorded(false)

                    notify('error', errorMessage?.invalidQrCode)
                }


            }
            // setIsDataRecorded(true)
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => { }
    const handleError = () => {

        notify('error', errorMessage?.somethingWentWrong)
        setIsDataRecorded(true)
    }

    const sendBack = () => {
        navigate(-1)
    }

    return (
        <div>
            <CommonQr
                isDisplayBack={true}
                handleClose={() => sendBack()}
                isParentCss={false}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
                notify={notify}
            />
        </div>
    )
}

ScanQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
}

ScanQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanQr)
